/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentSasUrlDto } from '../../models/document-sas-url-dto';

export interface DownloadUrlAsdSicherheitsbrief$Params {
  uuid: string;
}

export function downloadUrlAsdSicherheitsbrief(http: HttpClient, rootUrl: string, params: DownloadUrlAsdSicherheitsbrief$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentSasUrlDto>> {
  const rb = new RequestBuilder(rootUrl, downloadUrlAsdSicherheitsbrief.PATH, 'get');
  if (params) {
    rb.path('uuid', params.uuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DocumentSasUrlDto>;
    })
  );
}

downloadUrlAsdSicherheitsbrief.PATH = '/documents/asd-sicherheitsbrief/download/{uuid}';
